import { Circle } from "react-feather";

const Organisasi = [{
    id:"org",
    title:"Organisasi",
    icon:<Circle size={20}/>,
    children:[
        {
            id:"org-structure",
            title :"Struktur Organisasi",
            navLink:"/org/struktur-organisasi",
        },
        {
            id:"org-person-lists",
            title :"Daftar Pegawai",
            navLink:"/org/daftar-pegawai",
        },
    ]
}]

export default Organisasi
